import { z } from 'zod';

// Имя мерчанта — только латиница, цифры и пробел. Никаких «%», «&», кавычек,
// подчёркиваний, иероглифов и диакритики (правило Глеба 2026-07-27).
//
// Почему это контракт, а не «пожелание к данным»:
//   • имя едет в отгрузочную таблицу (Merchant_Name) и в ИМЯ ФАЙЛА, а имя
//     файла склеивается через подчёркивание —
//     `{PID}_IMG_{####}_{Pass_Type}_{Merchant}_{N}`. Мерчант вида `H_M` или
//     `Meetup_Zurich_Together` ломает разбор имени у принимающей стороны;
//   • `% Arabica` уехало в отгрузку и вернулось отказом (2026-07-27);
//   • нелатинское имя (`すかいらーく coupon`) заказчик прочитать не может.
//
// Нормализация не «чинит» плохое имя молча: если после чистки латинских букв
// не осталось, возвращается пустая строка — то есть мерчант считается
// НЕИЗВЕСТНЫМ, и кадром занимается крон `merchant-gate` (vision → доп.
// проверка QA). Пустое имя честнее огрызка вроде «coupon».

const APOSTROPHES = /['‘’ʼ`´]/g;

export function normalizeMerchantName(raw: string): string {
  const deaccented = String(raw || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(APOSTROPHES, '');
  if (/\p{Letter}/u.test(deaccented.replace(/[A-Za-z]/g, ''))) return '';
  const stripped = deaccented
    .replace(/[^A-Za-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return /[A-Za-z]/.test(stripped) ? stripped : '';
}

export function merchantNameOk(raw: string): boolean {
  const s = String(raw || '');
  return s.length > 0 && s === normalizeMerchantName(s);
}

/** Схема поля: принимает сырое имя, отдаёт нормализованное. */
export const MerchantNameSchema = z.string().transform(normalizeMerchantName);

/** Схема для мест, где имя ОБЯЗАНО быть уже нормализованным (отгрузка). */
export const StrictMerchantNameSchema = z.string().refine(merchantNameOk, {
  message: 'merchant must be latin letters, digits and spaces only',
});
